import * as React from 'react'
import type { SVGProps } from 'react'
const SvgVoteIoEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={138}
    height={115}
    viewBox="0 0 138 115"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_10034_1295)">
      <rect width={138} height={115} fill="white" />
      <path
        d="M126.461 84.8186C134.691 114.399 104.204 117.41 82.2034 108.478C69.3669 103.885 60.9369 118.17 45.0349 112.469C29.1329 106.768 48.1961 88.8093 23.8641 79.5924C-0.467831 70.3756 11.4108 29.1371 32.6774 28.662C53.9439 28.1869 48.1004 21.2505 69.3669 5.38223C90.6334 -10.486 126.461 11.5585 117.552 34.8383C108.643 58.1181 117.552 52.797 126.461 84.8186Z"
        stroke="#2C2F35"
      />
      <path
        d="M80.6904 61.7972C81.6399 64.6146 77.1923 69.1598 73.616 67.22C70.341 65.4438 67.0061 66.6417 64.8028 65.8498C59.0024 63.7651 61.136 62.6616 58.5431 60.1856C55.3878 57.1727 53.8822 49.2832 61.136 49.2832C67.1019 49.2832 65.3168 46.4091 69.7842 45.1356C74.2515 43.8621 79.3178 46.0299 79.3178 51.7371C79.3178 53.8803 79.1089 57.1047 80.6904 61.7972Z"
        stroke="#A7A8BA"
      />
      <path
        d="M122.301 82.8693C129.869 110.017 101.75 113.167 81.4241 104.871C69.4567 100.534 61.49 113.63 46.8333 108.375C31.8496 103.002 49.3738 86.5759 27.0181 77.9718C4.61125 69.3189 15.2731 31.1122 35.2658 30.6803C55.1414 30.2484 49.6668 23.6812 69.4061 9.13978C89.1455 -5.40168 122.176 14.8359 114.077 36.5182C105.978 57.8764 114.058 53.3322 122.301 82.8693Z"
        stroke="#A7A8BA"
      />
      <path
        d="M118.14 80.9205C125.046 105.635 99.2937 108.925 80.6427 101.265C69.5446 97.1832 62.041 109.089 48.6297 104.281C34.5644 99.237 50.5494 84.3428 30.17 76.3516C9.68836 68.2627 19.1335 33.0877 37.8523 32.699C56.3369 32.3103 51.2313 26.1124 69.4434 12.8978C87.6555 -0.316913 117.89 18.1137 110.601 38.1984C103.312 57.6352 110.563 53.8678 118.14 80.9205Z"
        stroke="#A7A8BA"
      />
      <path
        d="M113.98 78.9711C120.224 101.253 96.8393 104.682 79.8633 97.6572C69.6344 93.832 62.594 104.548 50.428 100.186C37.281 95.471 51.727 82.1092 33.3239 74.7307C14.7674 67.2058 22.9958 35.0626 40.4407 34.717C57.5343 34.3715 52.7976 28.543 69.4826 16.6551C86.1675 4.76726 113.605 21.3909 107.126 39.8781C100.647 57.3934 107.069 54.4029 113.98 78.9711Z"
        stroke="#A7A8BA"
      />
      <path
        d="M109.82 77.0215C115.403 96.8701 94.3849 100.439 79.0838 94.0497C69.7242 90.4806 63.147 100.007 52.2263 96.0911C39.9976 91.7049 52.9046 79.8754 36.4777 73.1098C19.8464 66.1489 26.858 37.0373 43.029 36.735C58.7317 36.4327 54.364 30.9734 69.5217 20.4123C84.6794 9.85128 109.321 24.6679 103.652 41.5576C97.9823 57.1514 103.576 54.9378 109.82 77.0215Z"
        stroke="#A7A8BA"
      />
      <path
        d="M105.658 74.9732C110.579 92.3887 91.9285 96.0971 78.3023 90.3434C69.812 87.0305 63.6979 95.3671 54.0226 91.8974C42.7122 87.8401 54.0802 77.5429 39.6296 71.39C24.9234 64.9931 30.7183 38.9133 45.6154 38.6542C59.9271 38.395 55.9283 33.3051 69.5589 24.0708C83.1894 14.8365 105.034 27.8462 100.175 43.1384C95.3156 56.8107 100.08 55.3739 105.658 74.9732Z"
        stroke="#A7A8BA"
      />
      <path
        d="M101.499 72.8081C105.757 87.7906 89.4739 91.6384 77.5227 86.5204C69.9016 83.4636 64.2508 90.6104 55.8208 87.5871C45.4287 83.8585 55.2576 75.0935 42.7833 69.5535C30.0022 63.7206 34.5804 40.6725 48.2036 40.4566C61.1244 40.2406 57.4945 35.52 69.5979 27.6125C81.7012 19.705 100.75 30.9077 96.7003 44.6024C92.6508 56.3531 96.5864 55.6933 101.499 72.8081Z"
        stroke="#FE9E67"
      />
      <path
        d="M97.3386 70.6364C100.935 83.1859 87.0193 87.1732 76.743 82.6909C69.9912 79.8901 64.8035 85.8472 57.6189 83.2701C48.1451 79.8703 56.435 72.6377 45.9369 67.7105C35.081 62.4416 38.4424 42.4252 50.7918 42.2524C62.3215 42.0797 59.0607 37.7283 69.6368 31.1476C80.2129 24.567 96.4651 33.9626 93.2255 46.0599C89.9858 55.8891 93.0925 56.0061 97.3386 70.6364Z"
        stroke="#A7A8BA"
      />
      <path
        d="M93.1765 68.4559C96.1116 78.5724 84.5625 82.6991 75.9612 78.8524C70.0786 76.3078 65.3541 81.0751 59.4148 78.9443C50.8594 75.8733 57.6102 70.1729 49.0884 65.8585C40.1577 61.1536 42.3023 44.169 53.3778 44.0394C63.5166 43.9098 60.6247 39.9278 69.6736 34.6739C78.7226 29.42 92.1782 37.0087 89.7485 47.5084C87.3188 55.4162 89.5966 56.31 93.1765 68.4559Z"
        stroke="#A7A8BA"
      />
      <path
        d="M89.0161 66.2611C91.2893 73.9445 82.1074 78.2108 75.1811 74.9997C70.1677 72.7112 65.9064 76.2888 61.2124 74.6043C53.5753 71.862 58.7871 67.6939 52.2416 63.9923C45.236 59.8514 46.1639 45.8985 55.9655 45.8121C64.7133 45.7258 62.1903 42.113 69.7121 38.1859C77.2338 34.2588 87.893 40.0406 86.2732 48.9428C84.6534 54.929 86.1023 56.5997 89.0161 66.2611Z"
        stroke="#A7A8BA"
      />
      <path
        d="M84.8531 64.0454C86.4645 69.2958 79.6497 73.7015 74.3984 71.1261C70.2542 69.0937 66.4561 71.4815 63.0075 70.2433C56.2887 67.8298 59.9614 65.194 55.3922 62.1052C50.3117 58.5283 50.0229 47.6071 58.5506 47.5639C65.9075 47.5207 63.7534 44.2773 69.748 41.677C75.7425 39.0767 83.6052 43.0515 82.7953 50.3561C81.9854 54.4209 82.6054 56.8685 84.8531 64.0454Z"
        stroke="#A7A8BA"
      />
      <path
        d="M96.3817 38.8495L93.0067 48.0077C92.9068 48.2768 92.727 48.5089 92.4913 48.6729C92.2556 48.8368 91.9754 48.9246 91.6884 48.9246C91.4013 48.9246 91.1211 48.8368 90.8855 48.6729C90.6498 48.5089 90.4699 48.2768 90.37 48.0077L86.995 38.8495C86.9238 38.6562 86.8115 38.4807 86.6658 38.335C86.5201 38.1893 86.3446 38.077 86.1513 38.0058L76.9931 34.6308C76.7239 34.5309 76.4918 34.351 76.3279 34.1153C76.164 33.8797 76.0762 33.5995 76.0762 33.3124C76.0762 33.0253 76.164 32.7451 76.3279 32.5095C76.4918 32.2738 76.7239 32.0939 76.9931 31.994L86.1513 28.619C86.3446 28.5478 86.5201 28.4355 86.6658 28.2898C86.8115 28.1441 86.9238 27.9686 86.995 27.7753L90.37 18.6171C90.4699 18.348 90.6498 18.1159 90.8855 17.952C91.1211 17.788 91.4013 17.7002 91.6884 17.7002C91.9754 17.7002 92.2556 17.788 92.4913 17.952C92.727 18.1159 92.9068 18.348 93.0067 18.6171L96.3817 27.7753C96.453 27.9686 96.5653 28.1441 96.711 28.2898C96.8566 28.4355 97.0322 28.5478 97.2255 28.619L106.384 31.994C106.653 32.0939 106.885 32.2738 107.049 32.5095C107.213 32.7451 107.301 33.0253 107.301 33.3124C107.301 33.5995 107.213 33.8797 107.049 34.1153C106.885 34.351 106.653 34.5309 106.384 34.6308L97.2255 38.0058C97.0322 38.077 96.8566 38.1893 96.711 38.335C96.5653 38.4807 96.453 38.6562 96.3817 38.8495V38.8495Z"
        stroke="#2C2F35"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102.938 10.8125V19.25"
        stroke="#2C2F35"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M107.156 15.0312H98.7188"
        stroke="#2C2F35"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M111.375 20.6562V26.2812"
        stroke="#2C2F35"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M114.188 23.4688H108.562"
        stroke="#2C2F35"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10034_1295">
        <rect width={138} height={115} fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgVoteIoEmpty
